/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { DropdownButton, MenuItem } from 'react-bootstrap';

const rates = [0.65, 0.8, 1, 1.1, 1.25, 1.5, 2, 2.5, 3];

const SpeedControlButton = (props) => {
  const title = (
    <span>
      Speed: <b>{`${props.playbackRate}x`}</b>
    </span>
  );

  return (
    <DropdownButton
      id={_.uniqueId()}
      title={title}
      style={{ backgroundColor: 'transparent', boxShadow: 'none' }}
    >
      {rates.map((rate) => {
        const classes = classNames({
          active: rate === props.playbackRate,
        });

        return (
          <MenuItem
            key={rate}
            className={classes}
            eventKey={rate}
            onSelect={(eventKey, event) => {
              props.setPlaybackRate(eventKey);

              global.analytics.track('set playback rate', {
                rate,
                ...props.analyticsPayload,
              });
            }}
          >
            <b>{`${rate}x`}</b>
          </MenuItem>
        );
      })}
    </DropdownButton>
  );
};

SpeedControlButton.propTypes = {
  playbackRate: PropTypes.oneOf(rates),
  setPlaybackRate: PropTypes.func,
};

SpeedControlButton.getDefaultProps = {
  playbackRate: 1,
};

export default SpeedControlButton;
